import moment from "moment";
import Zemen from "../UIComponents/ZemenCalendar/zemen";

export function  multiDateFun(calendar, gcDate, format) {
    return calendar==='EC'?Zemen.toEC(gcDate).format(format):moment(gcDate).format(format)
}
